export default __webpack_public_path__ + "static/screeny-130-gpz-mb-1-01fb25faffaff3b41fd873e766fd4c9d.jpg";